import { render, staticRenderFns } from "./ReclaimEventManage.vue?vue&type=template&id=166ca9f4&scoped=true&"
import script from "./ReclaimEventManage.vue?vue&type=script&lang=js&"
export * from "./ReclaimEventManage.vue?vue&type=script&lang=js&"
import style0 from "./ReclaimEventManage.vue?vue&type=style&index=0&id=166ca9f4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "166ca9f4",
  null
  
)

export default component.exports